
import React from 'react';
import { connect } from 'react-redux';
import { changeRoute } from '../SideBarActions';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

const mapState = state => ({
  activeRoute: state.sidebar && state.sidebar.activeRoute
});

const actions = {
  changeRoute
}

class CustomNavLink extends React.Component {
  static propTypes = {
    activeRoute: PropTypes.string,
    changeRoute: PropTypes.func.isRequired,
  };


  handleClick = () => {
    this.props.changeRoute(this.props.to);
  }

  render() {
    const { children, to, className } = this.props;
    return <NavLink className={className} to={to} onClick={this.handleClick}>{children}</NavLink>;
  }
}

export default connect(mapState, actions)(CustomNavLink);
